/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../apimodel.d.ts" />
/// <reference path="../app.common.directives.module.ts" />
/// <reference path="validatorbase.ts" />
/// <reference path="validateargs.ts" />
/// <reference path="../../services/globalsettingsservice.ts" />

module App.Common.Directives {
	'use strict';

	export abstract class DateValidatorBase extends Directives.ValidatorBase {

		public static $inject = ['$filter', 'app.common.services.globalSettingsService'];

		constructor(protected $filter: angular.IFilterService,
			protected globalSettings: Common.Services.GlobalSettingsService) {
			super();
		}

		public comparisonDescription: string;

		public canValidate = (args: Directives.ValidateArgs) => {
			return args.modelValue() &&
				args.parameterValue() &&
				(_.isDate(args.modelValue()) || _.isDate(new Date(args.modelValue()))) &&
				(_.isDate(args.parameterValue()) || _.isDate(new Date(args.parameterValue())));
		};
		public getWatchExpressions = (args: Directives.ValidateArgs) => {
			return [args.parameter, args.attributes.ngModel];
		};
		public resolveMessage = (args: ValidateArgs): string => {
			var label = args.attributes[`${this.nameCamelCase()}Label`] ||
				this.$filter('date')(args.parameterValue(), this.globalSettings.shortDateFormat);
			return `This date must be ${this.comparisonDescription} ${label}`;
		};
	}

}